import { BrokenImgDirective } from './broken-img.directive';


export const DIRECTIVES = [BrokenImgDirective];

